import React, {useState} from "react";
import {MultiFactorResolver, TotpMultiFactorGenerator} from "firebase/auth";
import {Box, Button, Stack, TextField, Typography} from "@mui/material";


interface CodeStepProps {
    mfaResolver: MultiFactorResolver;
    enrollmentId: string;
}

const MFACodeStep: React.FC<CodeStepProps> = ({mfaResolver, enrollmentId}) => {
    const [code, setCode] = useState("");
    const [error, setError] = useState<string>("");

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value.replace(/\D/g, "")); // Ensure only numbers are entered
        if (error) setError(""); // Clear error on input
    };

    const handleSubmit = async () => {
        try {
            const assertion = TotpMultiFactorGenerator.assertionForSignIn(enrollmentId, code);
            await mfaResolver.resolveSignIn(assertion);

            console.info("MFA successfully completed.");
        } catch (err: any) {
            if (err.code === "auth/totp-challenge-timeout") {
                setError("De code is verlopen. Probeer het opnieuw.");
            } else {
                setError("De code is onjuist. Probeer het opnieuw.");
            }
            setCode("");
            console.warn("MFA code verification failed:", err);
        }
    };

    const handleKeyPress = async (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            await handleSubmit();
        }
    };

    return (
        <Box>
            <Stack>
                <Typography variant="h6">🔒 Authentication Code</Typography>

                <TextField
                    label="Enter your code"
                    variant="outlined"
                    inputMode="numeric"
                    slotProps={{htmlInput: {maxLength: 6}}}
                    value={code}
                    onChange={handleChange}
                    onKeyDown={handleKeyPress}
                    fullWidth
                />

                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={!code}>
                    Submit
                </Button>

                {error && <Typography color="error">{error}</Typography>}
            </Stack>
        </Box>
    );
};

export default MFACodeStep;
